import { Cell, CellGroup } from 'vant'
import { formatDate } from 'Utils/dateUtil'
import Bussiness from 'Utils/business'

export default {
  name:'HtRefundComplete',
  components: {
    [Cell.name]: Cell,
    [CellGroup.name]: CellGroup,
    ldButton: () => import('Common/ldButton'),
    ldTabbar: () => import('Components/ldTabbar/ldTabbar'),
    MescrollVue: () => import('mescroll.js/mescroll.vue'),
  },
  props: {
    id: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      mescroll: null, // mescroll实例对象
      data_: {},
      mescrollDown: {
        callback: this.loadData,
      },
      htRefundDaysWeek: []
    }
  },
  mounted() {
    /**
     * 初始化数据
     */
    this.loadData()
  },
  created() { },
  methods: {
    mescrollInit (mescroll) {
      this.mescroll = mescroll  // 如果this.mescroll对象没有使用到,则mescrollInit可以不用配置
    },
    loadData() {
      this.$api['htQuery/hotelRefundDetail']({
        hotelRefundId: this.id
      }).then(res => {
        this.data_ = res.data
        console.log(this.data_.htRefundDays)
        this.htRefundDaysWeek = []
        this.data_.htRefundDays.split(',').forEach(element => {
          this.htRefundDaysWeek.push({
            day: element,
            week: formatDate(element).week
          })
        });
        console.log(this.htRefundDaysWeek)
        this.data_._htRefundDaysWeek = formatDate(this.data_.htRefundDays).week
        this.$nextTick(() => { // 数据渲染成功后,隐藏下拉刷新的状态
          this.mescroll.endSuccess()
        })
      }).catch(() => {})
    },
    sendApproval() { // 送审
      this.data_.orderType = '10903'
      let items = JSON.parse(JSON.stringify(this.data_))
      items.orderNo = items.refundNo
      items.orderId = items.htRefundId
      Bussiness.ApprovalSend(items)
    },
  },
  watch: {}
}